import { useTranslation } from 'react-i18next'

import HistoryDrawer from '@/common/components/HistoryDrawer/HistoryDrawer'

import { formatSettingsEvent } from './helpers'

const SettingsHistoryDrawer = ({ show, onClose, fieldKeys, returnPortalId, objectId }) => {
  const { t } = useTranslation()

  const formatEvent = event => formatSettingsEvent(event, t)

  return (
    <HistoryDrawer
      show={show}
      onClose={onClose}
      title={t('Historial de la página')}
      fieldKeys={fieldKeys}
      returnPortalId={returnPortalId}
      objectId={objectId}
      formatEvent={formatEvent}
    />
  )
}

export default SettingsHistoryDrawer
